import {useEffect, useState} from "react";
import {memberApiType} from "../../../settings/Member/API/request/member/memberApi.interface";
import {checkLogin} from "../../../../@WUM/templates/default/Auth/service/AuthService";
import {error} from "../../../../@WUM/core/component/const/error.services";
import {user} from "../request/user";

export const Response = (limit: any, searchValue: any,fetchData:any) => {
    const [posts, setPosts] = useState<memberApiType[]>([])
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await user
                .getUser(limit, searchValue)
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [limit, searchValue,fetchData])

    return isError ? isError : posts
}
